<div class="app-table-filter app-table-filter__wrapper cap-table-filter">
  <div class="d-flex">
    <div class="filters-label">
      {{ 'table.filters' | translate }}
    </div>

    <div class="filters-wrapper d-flex w-100">
      <div class="row" *ngIf="activeFilters">
        <div
          class="align-vertical filter-row col-12 col-md-4 mb-2"
          [ngClass]="filter.wrapperStyleClass"
          *ngFor="let filter of filters">
          <ng-container [ngSwitch]="filter.type">
            <cap-input
              *ngSwitchCase="filterType.INPUT"
              class="has-icon"
              styleClass="cap-rounded"
              [attr.data-field]="filter.field"
              [disabled]="filter?.disabled"
              [ngModel]="filter.isSearch ? activeFilters?.global?.value : activeFilters[filter.field]?.value"
              [placeholder]="filter.placeholder | observablePipe | async"
              #input>
            </cap-input>

            <ng-container *ngSwitchCase="filterType.MULTISELECT">
              <ng-container *ngIf="filter.options | observablePipe| async as options">
                <cap-multi-select class="has-icon"
                                  [options]="options"
                                  [sortAlphabetically]="filter.sortAlphabetically !== undefined ? filter.sortAlphabetically: true"
                                  [disabled]="filter?.disabled"
                                  *ngSwitchCase="filterType.MULTISELECT"
                                  styleClass="cap-rounded"
                                  [defaultLabel]="filter.placeholder | observablePipe | async"
                                  (change)="setFilter($event.value, filter.field, 'in')"
                                  [ngModel]="activeFilters[filter.field]?.value">
                </cap-multi-select>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'dropdown'">
              <ng-container *ngIf="filter.options | observablePipe| async as options">
                <cap-dropdown
                  [options]="options"
                  styleClass="cap-rounded"
                  [disabled]="filter?.disabled"
                  [placeholder]="filter.placeholder | observablePipe | async"
                  (change)="setFilter($event.value, filter.field, 'in')"
                  [ngModel]="activeFilters[filter.field]?.value"
                >

                </cap-dropdown>
              </ng-container>

            </ng-container>
            <cap-calendar *ngSwitchCase="filterType.DATEPICKER"
                          styleClass="cap-rounded w-100"
                          [readonlyInput]="true"
                          [ngModel]="activeFilters[filter.field]?.value"
                          (select)="setFilter($event, filter.field, filter.matchMode || 'equals')"
                          [placeholder]="filter.placeholder | observablePipe | async">
            </cap-calendar>

            <div class="int-checkbox-filter-container" *ngSwitchCase="filterType.INPUT_SWITCH">
              <div class="int-checkbox-filter-container__int-checkbox-filter">
                <div class="int-checkbox-filter-container__int-checkbox-filter--int-checkbox-filter-label">
                  {{ filter.label }}
                </div>

                <cap-checkbox [binary]="true" [ngModel]="activeFilters[filter.field]?.value"
                              (change)="setInputSwitchFilter($event.checked, filter.field)"></cap-checkbox>
              </div>
            </div>
          </ng-container>

          <ng-container *ngTemplateOutlet="filterIcon; context:{icon: filter.icon}">
          </ng-container>
        </div>
      </div>

      <div class="filter-buttons">
        <cap-button [label]="'intergrip.button.reset' | translate"
                    styleClass="primary cap-rounded float-right"
                    (click)="reset()">
        </cap-button>
      </div>
    </div>

  </div>
</div>
<div class="app-table-filter__sliders-icon">
  <i [ngClass]="[fontAwesomeIcon.SlidersH, 'fa-2x']"
     (click)="openLogsSidebar()"></i>
</div>
<ng-template #filterIcon let-icon="icon">
  <div class="filter-icon">
    <i [ngClass]="icon"></i>
  </div>
</ng-template>
